// extracted by mini-css-extract-plugin
module.exports = {"login":"index_login__32YP2","main":"index_main__9a-QG","form":"index_form__dcBJ2"};